import type { ReactNode } from "react";

import { cn } from "@monorepo-apps/ui/src/lib/utils";

interface SectionLabelProps {
  label: string;
  icon?: ReactNode;
  tone?: "default" | "accent";
  children: ReactNode;
}

export function SectionLabel({ label, icon, tone = "default", children }: SectionLabelProps) {
  return (
    <section
      data-slot="timeline-v2-section"
      className={cn(
        "flex flex-col gap-1.5",
        tone === "accent" && "border-l-2 border-[oklch(0.72_0.17_190_/_0.4)] pl-3"
      )}
    >
      <SectionHeader label={label} icon={icon} tone={tone} />
      <div className="text-foreground/85 text-[13px] leading-relaxed">{children}</div>
    </section>
  );
}

function SectionHeader({
  label,
  icon,
  tone,
}: {
  label: string;
  icon?: ReactNode;
  tone: "default" | "accent";
}) {
  return (
    <div className="flex items-center gap-1.5">
      {icon ? (
        <span
          className={cn(
            "inline-flex h-3 w-3 items-center justify-center",
            tone === "accent" ? "text-[oklch(0.55_0.17_190)]" : "text-muted-foreground"
          )}
        >
          {icon}
        </span>
      ) : null}
      <span className="eyebrow">{label}</span>
    </div>
  );
}
